<template>
	<span>{{ $filters.ukDateTime(number_time) }}</span>
</template>

<script>
export default {
	props: {
		time: {
			type: String
		}
	},
	computed: {
		number_time() {
			return parseInt(this.time);
		}
	}
}
</script>
